export const URL_API_PINNED_PROJECT =
  "https://gh-pinned-repos-tsj7ta5xfhep.deno.dev/?username=devntv";
